import React from "react";
import { motion } from "framer-motion";
import {
  ArrowRight,
  ArrowUpRight,
  Briefcase,
  Globe,
  TrendingUp,
  Users,
  FileText,
  Calendar,
} from "lucide-react";
import { Link } from "react-router-dom";
import ServiceCard from "../components/ServiceCard";
import ClientLogo from "../components/ClientLogo";
import NewsCard from "../components/NewsCard";

const HomePage = () => {
  const services = [
    {
      icon: <Briefcase className="text-primary" size={24} />,
      title: "Company Formation",
      description:
        "Complete company registration from RGSC services including documentation preparation, submission, and follow-up.",
    },
    {
      icon: <TrendingUp className="text-primary" size={24} />,
      title: "BIDA Registration",
      description:
        "Registration with Bangladesh Investment Development Authority for foreign investments and joint ventures.",
    },
    {
      icon: <Globe className="text-primary" size={24} />,
      title: "Visa & Work Permit",
      description:
        "Processing of visa applications and work permits for foreign nationals working in Bangladesh",
    },
    {
      icon: <FileText className="text-primary" size={24} />,
      title: "IRC & ERC Registration",
      description:
        "Import Registration Certificate and Export Registration Certificate processing for trading businesses.",
    },
  ];

  const clients = [
    {
      id: 1,
      name: "United Group",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhnte8EuItHgdKpHVqrzfNrcQvaBvXbArODpw_fuwa-FlLcyLWfttEZeQjHtxb4SdlDhTjWjXcnAX4IyZouF_Ox1EoDgsRWJitTwAQ8LFKg99UbvQ9iFuynmSFfcaTWOUkgyZNVMl-k0AwZDRzXCUuGT14KKh6wBN_XDlqbW0BH72w9AvQkkkkCF9fCZxg/s320/1.jpg",
    },
    {
      id: 2,
      name: "Reza Group",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgxRR8WiXpG63xwkrnbZY0fxsm_XPnYLLYB80o47OanCBu30HwMowcvEARBpGFcHDYGN6ETvx-ruE7UrKNd8yRqNdfnePsn2xU1YnNvXbyJ5o3JP8xcEDvL13SKrRy16yQXsgRXFG6AkJaam4C6gr2pFTdSHwdmx566mev3ujrnJgGVJPPT6eal2BkjHfE/s320/2.jpg",
    },
    {
      id: 3,
      name: "CRONY Group",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhaWkmzlLy4hCtv28Eeuwe49kuDeRmE3dBsdow1L_S1MwY0CvpvFNWeeYNR-izRlgEVUSIwk-qdxCk1Nh_zsv7-lRuInvlrEJ2PGQUABJXRTPO-L4b40TYnqhJO30SxZDgS0ik4Sw6tZK4AiHPAQ26JQDy3C2uYJcUBMWz06EZo0b246UzqgMJj_8YyI8w/s320/3.png",
    },
    {
      id: 4,
      name: "Bracket Limited",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjnSrsWMjawayIVvmJLdIynPXqTjE9hydHn3VjA10gtxEz5t9YToyJ8MqKN7dIZ0m339Qooz1QhAEzG4FLS6iVjJQIlX-TsnMFjm4yuqSr-2Ua9NKWJ7AIlZ9fV8A6BrOhw03vN9i4jc-93ftTuCWIsfdIuktDpjGYTBScAEJMOYHbR7IPKBkTLeE3Q7C8/s320/4.png",
    },
    {
      id: 5,
      name: "Export Tex",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEihyQgAcdvmmS5H1oTXhKKAWQEhAehwu99jwSiGlBhvL5PXYkrQp0sEwNOgiXDLIw3jfFdTCwr1GzC44OpOqyeJsZTiHrEWDNdGLF65gacqT1R0CSQDpfnJR-qI_YZkK-T2FF0UQWOtzJx___-Su_3mEQvVl1qpJ4uPRo2lB28KFFqJPUs9f0JvgXPMTyY/s320/5-EXPORT%20TEX.jpg",
    },
    {
      id: 6,
      name: "RS Technology",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgT4MgxUyMNzZJk5Csgz4EWJoiTnctGiN9kQJnTnxNeHPQjIGp2OuKDLnl_QFcCr3UCCJg5RSJrVPPk4m70rJoURvRPZrzg82ZG-1NNhLRt0dxDkOLeouaOuvk1l7e3JtPjINlqTzK8EizqF7g1In4Ku4X0dXoxVDbpbmpd-R0FRibG7N6nBp_f-ZIH5og/s320/6-Rs%20Technology.jpg",
    },
    {
      id: 7,
      name: "TEX Bridge",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhBSXztlUcLU1RXC1aKIAXt5bsyYTXmBpr29vqvbR0igc4RZtyENystC6bzJL8Q03ukQzR4GtxGYPmYZq3alyRCOnDjXZ5hautZoEiZKWY45y72dY1r5gYIuGiGbzgemoJkz2fBqgKsd87ZTssE7a36ewD9DTO1NgTjj5X6sqpR-MTlOToxwYEa4d5FdPc/s1600/8-Texbridge.png",
    },
    {
      id: 8,
      name: "CAFE Kabbo",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgKLJaClVxFYS4fQc4BZb84xeI2jmW_2sp2zAZZfUQhgJNNXPvqmlNY7r_H0iTkE0QfmO7LsfOrEEIqK-er_EUjy5oWemx012T97dIW8IVh3GbhwSn4h8kOXLgmLj9QrDwQTAXg8ube4-Ng3oljkzoFrKWk5-jAtH6koCl3UIoV1eg4ijA4vEmjU1oWcJA/s320/9-Cafekabbo.jpg",
    },

    {
      id: 9,
      name: "Advance Agro",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEizt40v3X-lxRsBf2xzn2OxF-G7S3R4W-qS_vIwWtIQReMWr4A90VFAWBqC_ddYgNfrBTJ5dli9ggbNVwuvH74VK90JcX_XRPgp7aN76tW1H63aVS9fqLpSYuEP09d13BK9nekvETtV8KvReMbyH5GIoJJV8VxAYtTCXU7gwPCE5vlr9HTnnQzpUFpAiLc/s1600/WhatsApp%20Image%202025-06-21%20at%205.13.55%20PM.jpeg",
    },
    {
      id: 10,
      name: "Inspiration FItness and Diet COnsultancy Center",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEissypRBzckQDqUsFERLMGOeVuHA7sznrUz6t-xun_k3NEE5sm-mwIfvl-dz-gsNtYceKHeSoHxXNXhIPzB3DRuMAO2Mv1irIShhJSUMqQWGPzYWb68XDzqiEgGV-maSziWPFlhOjNwdWexU5pj5GssEZ8TqYEowy7nRdn2onmBR52ZRztlXX7xoz6UXaU/s320/Inspiron%20Fitness%20and%20Diet%20Consultancy%20Center.jpg",
    },
  ];

  const news = [
    {
      id: 1,
      title: "New Foreign Investment Guidelines for 2025",
      excerpt:
        "Breakdown of the latest foreign investment regulations and how they'll impact businesses.",
      image:
        "https://images.pexels.com/photos/7681022/pexels-photo-7681022.jpeg",
      date: "May 15, 2025",
      category: "Investment",
    },
    {
      id: 2,
      title: "Digital Transformation Success Stories",
      excerpt:
        "Case studies of companies that successfully implemented digital ecosystem strategies.",
      image:
        "https://images.pexels.com/photos/6476260/pexels-photo-6476260.jpeg",
      date: "April 28, 2025",
      category: "Digital",
    },
    {
      id: 3,
      title: "Business Innovation Workshop Announced",
      excerpt:
        "Join our upcoming workshop focused on innovation strategies for growing businesses.",
      image:
        "https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg",
      date: "April 10, 2025",
      category: "Events",
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero-pattern relative py-20 md:py-32 overflow-hidden">
        <div className="container relative z-10">
          <div className="max-w-3xl mx-auto text-center text-white mb-8">
            <motion.h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Expert Consulting for Global Business Success
            </motion.h1>
            <motion.p
              className="text-lg md:text-xl text-gray-200 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Specialized in foreign investment, business innovation, and
              digital ecosystems to transform your business for the global
              market.
            </motion.p>
            <motion.div
              className="flex flex-col sm:flex-row justify-center gap-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <Link to="/contact" className="btn-accent">
                Get Started
              </Link>
              <Link to="/about" className="btn-secondary">
                Learn More
              </Link>
            </motion.div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-background to-transparent"></div>
      </section>

      {/* Services Section */}
      <section className="py-20">
        <div className="container">
          <div className="text-center mb-12">
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Our Services
            </motion.h2>
            <motion.p
              className="section-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              We provide comprehensive consulting services to help businesses
              navigate complex international markets and drive innovation
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
              >
                <ServiceCard {...service} />
              </motion.div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/local-services"
              className="inline-flex items-center text-primary font-medium hover:text-primary-light transition-colors"
            >
              View All Services <ArrowRight size={16} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 sm:py-20 relative bg-gray-50">
        {/* Subtle geometric pattern background */}
        <div className="absolute inset-0 geometric-pattern opacity-20 pointer-events-none"></div>

        <div className="relative z-10">
          <div className="container px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              {/* Text Content */}
              <motion.div
                className="order-2 lg:order-1"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <h2 className="section-title mb-4">Who We Are</h2>
                <p className="text-text-light mb-4 text-base sm:text-lg leading-relaxed text-justify">
                  Venturex Consult Service is a premier consulting firm
                  specializing in helping businesses navigate the complexities
                  of foreign investment, business registration, and digital
                  transformation in Bangladesh and beyond.
                </p>
                <p className="text-text-light mb-6 text-base sm:text-lg leading-relaxed text-justify">
                  With our team of experts in legal compliance, business
                  strategy, and technology innovation, we provide end-to-end
                  solutions that help our clients achieve their business
                  objectives efficiently and effectively.
                </p>

                {/* Feature Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                  {[
                    {
                      icon: <Users size={20} className="text-primary" />,
                      label: "Expert Team",
                      desc: "Experienced professionals",
                    },
                    {
                      icon: <Globe size={20} className="text-primary" />,
                      label: "Global Reach",
                      desc: "International networks",
                    },
                    {
                      icon: <Calendar size={20} className="text-primary" />,
                      label: "10+ Years",
                      desc: "Industry experience",
                    },
                    {
                      icon: <Briefcase size={20} className="text-primary" />,
                      label: "500+ Projects",
                      desc: "Successfully delivered",
                    },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start">
                      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4">
                        {item.icon}
                      </div>
                      <div>
                        <h3 className="font-medium text-lg">{item.label}</h3>
                        <p className="text-sm text-text-light">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <Link to="/about" className="btn-primary w-fit">
                  Learn More About Us
                </Link>
              </motion.div>

              {/* Image */}
              <motion.div
                className="order-1 lg:order-2"
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <img
                  src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg"
                  alt="Team of professionals"
                  className="rounded-lg shadow-lg w-full h-auto object-cover"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section className="py-20">
        <div className="container">
          <div className="text-center mb-12">
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Our Trusted Clients
            </motion.h2>
            <motion.p
              className="section-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              We've partnered with leading organizations to deliver exceptional
              results
            </motion.p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {clients.map((client) => (
              <motion.div
                key={client.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * client.id }}
              >
                <ClientLogo name={client.name} image={client.image} />
              </motion.div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <Link
              to="/clients"
              className="inline-flex items-center text-primary font-medium hover:text-primary-light transition-colors"
            >
              View All Clients <ArrowRight size={16} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="py-20 bg-gray-50">
        <div className="container">
          <div className="text-center mb-12">
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              News & Updates
            </motion.h2>
            <motion.p
              className="section-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Stay informed with the latest business trends, regulatory changes,
              and company updates
            </motion.p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {news.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
              >
                <NewsCard {...item} />
              </motion.div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <Link
              to="/news"
              className="inline-flex items-center text-primary font-medium hover:text-primary-light transition-colors"
            >
              View All News <ArrowRight size={16} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-white">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <motion.h2
              className="text-3xl md:text-4xl font-bold mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Ready to Transform Your Business?
            </motion.h2>
            <motion.p
              className="text-lg text-gray-200 mb-8 max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Contact us today for a consultation and discover how Venturex can
              help you navigate global markets, streamline operations, and drive
              innovation.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <Link
                to="/contact"
                className="btn-accent inline-flex items-center"
              >
                Contact Us <ArrowUpRight size={16} className="ml-2" />
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
